import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { FeatureToggle } from 'react-feature-toggles';
import { withAuth0 } from '@auth0/auth0-react';
import { connect } from 'react-redux';
import { hasPermission } from 'v2/utils/permissions';

class ProtectedRoute extends React.Component {
  render() {
    const {
      component,
      noproviders,
      nobuyers,
      nonewusers,
      user,
      permissions,
      permissionsState,
      dispatch,
      featureFlag,
      ...rest
    } = this.props;
    const { isAuthenticated, isLoading } = this.props.auth0;
    const Component = this.props.component;

    return (
      <Route
        {...rest}
        render={(props) => {
          if (isLoading) {
            return null;
          }
          if (!user || !isAuthenticated) {
            return (
              <Redirect
                to={{ pathname: '/logout', state: { from: props.location } }}
              />
            );
          } else if (nonewusers && user.user.new_user) {
            return (
              <Redirect
                to={{
                  pathname: user.user.isInvited ? '/apply-invite' : '/apply',
                }}
              />
            );
          } else if (noproviders && user.user.data_provider) {
            return (
              <Redirect
                to={{ pathname: '/data-requests/active/waiting-seller' }}
              />
            );
          } else if (nobuyers && !user.user.data_provider) {
            return <Redirect to={{ pathname: '/' }} />;
          } else if (
            permissions &&
            !hasPermission(permissionsState, permissions)
          ) {
            return <Redirect to={{ pathname: '/' }} />;
          } else if (featureFlag) {
            return (
              <>
                <FeatureToggle featureName={featureFlag}>
                  <Component {...props} {...rest} />
                </FeatureToggle>
                <FeatureToggle featureName={featureFlag} showOnlyWhenDisabled>
                  <Redirect to={{ pathname: '/' }} />
                </FeatureToggle>
              </>
            );
          } else {
            return <Component {...props} {...rest} />;
          }
        }}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    permissionsState: state.permissions.permissions,
  };
};

export default connect(mapStateToProps)(withAuth0(ProtectedRoute));
